module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//pet-box_1.png?v=5bdfb295";